import { useLocalization } from "@i18n";

export interface InspectionFinalizedKpiCardProps {
  finalizedCount: number | null;
}

/**
 * Único card KPI da v1 (inspection.md §6.1): `Finalizadas` = inspeções com
 * status `finalizada`. Visual alinhado ao protótipo (kpi-card).
 */
const InspectionFinalizedKpiCard = ({
  finalizedCount,
}: InspectionFinalizedKpiCardProps) => {
  const { translate } = useLocalization();

  return (
    <section
      data-testid="inspection-kpi-finalized"
      aria-labelledby="inspection-kpi-finalized-label"
      className="insp-card insp-kpi-card"
    >
      <p id="inspection-kpi-finalized-label" className="insp-kpi-label">
        {translate("inspection.kpi.finalized")}
      </p>
      <p className="insp-kpi-value">
        {finalizedCount === null
          ? translate("inspection.table.fallback")
          : finalizedCount}
      </p>
    </section>
  );
};

export default InspectionFinalizedKpiCard;
